import { Box } from "@mui/material";

import { EntityChipList } from "@/common/components/EntityInfo/EntityChipList";
import InlineApiEnumValue from "@/common/components/Enum/InlineApiEnumValue";
import AppTypography from "@/common/components/Text/AppTypography";
import { renderIf } from "@/common/helpers/render/renderIf";
import { EntityViewVariant } from "@/common/ts/layout";
import {
  GeneralHistoryDto,
  GeneralHistoryEventType,
  GeneralHistoryEventTypeOfVehicle,
  GeneralHistoryType,
} from "@/core/api/generated/v1";

interface Props {
  item: GeneralHistoryDto;
}

export default function GeneralHistoryItemTitle({ item }: Props) {
  return (
    <Box>
      {renderIf()
        .if(item.type === GeneralHistoryType.Log)
        .then(<Box>{item.log?.message}</Box>)
        .elseif(item.type === GeneralHistoryType.Event)
        .then(
          <>
            {renderIf()
              .if(item.event?.type === GeneralHistoryEventType.Arbitrary)
              .then(<Box>{item.event?.arbitrary?.name}</Box>)
              .elseif(item.event?.type === GeneralHistoryEventType.Vehicle)
              .then(
                <Box>
                  {renderIf()
                    .if(
                      item.event?.vehicle?.type === GeneralHistoryEventTypeOfVehicle.MileageChanged,
                    )
                    .then(
                      <>
                        Mileage changed from{" "}
                        {item.event?.vehicle?.mileageChanged?.oldMileage?.mileage}{" "}
                        {
                          <InlineApiEnumValue
                            type='MileageUnit'
                            value={item.event?.vehicle?.mileageChanged?.oldMileage?.unit}
                          />
                        }{" "}
                        to {item.event?.vehicle?.mileageChanged?.newMileage?.mileage}{" "}
                        {
                          <InlineApiEnumValue
                            type='MileageUnit'
                            value={item.event?.vehicle?.mileageChanged?.newMileage?.unit}
                          />
                        }
                      </>,
                    )
                    .elseif(
                      item.event?.vehicle?.type ===
                        GeneralHistoryEventTypeOfVehicle.MileageCorrected,
                    )
                    .then(
                      <>
                        Mileage corrected from{" "}
                        {item.event?.vehicle?.mileageCorrected?.oldMileage?.mileage}{" "}
                        {
                          <InlineApiEnumValue
                            type='MileageUnit'
                            value={item.event?.vehicle?.mileageCorrected?.oldMileage?.unit}
                          />
                        }{" "}
                        to {item.event?.vehicle?.mileageCorrected?.newMileage?.mileage}{" "}
                        {
                          <InlineApiEnumValue
                            type='MileageUnit'
                            value={item.event?.vehicle?.mileageCorrected?.newMileage?.unit}
                          />
                        }
                      </>,
                    )
                    .else(
                      <InlineApiEnumValue
                        type='GeneralHistoryEventTypeOfVehicle'
                        value={item.event?.vehicle?.type}
                      />,
                    )
                    .render()}
                </Box>,
              )
              .elseif(item.event?.type === GeneralHistoryEventType.VehicleDamage)
              .then(
                <Box>
                  <InlineApiEnumValue
                    type='GeneralHistoryEventTypeOfVehicleDamage'
                    value={item.event?.vehicleDamage?.type}
                  />
                </Box>,
              )

              .else(
                <AppTypography color='error'>
                  History event of type {item.event?.type} is not supported.
                </AppTypography>,
              )
              .render()}
          </>,
        )
        .else(
          <AppTypography color='error'>
            History item of type {item.type} is not supported.
          </AppTypography>,
        )
        .render()}{" "}
      <EntityChipList entity={item} entityViewVariant={EntityViewVariant.List} variant='compact' />
    </Box>
  );
}
